import { render } from "./CategorySetMode.vue?vue&type=template&id=40d16bd3&scoped=true"
import script from "./CategorySetMode.vue?vue&type=script&lang=js"
export * from "./CategorySetMode.vue?vue&type=script&lang=js"

import "./CategorySetMode.vue?vue&type=style&index=0&id=40d16bd3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d16bd3"]])

export default __exports__